import StyledFooter from '../../blocks/Footer';

const Footer = StyledFooter;

export default Footer;
